import { useState } from "react";
import axios from "axios";
import { Share2 } from "lucide-react";
import { toast } from "sonner";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { API } from "@/lib/api";
import { ideasStore } from "@/lib/storage";
import { accountHeaders } from "@/lib/account";
import { DailyPushToggle } from "@/components/DailyPushToggle";
import { SocialShare } from "@/components/SocialShare";

export const shareText = (idea) => `${idea.nome} — voto AI ${Number(idea.punteggio_complessivo || 0).toFixed(1)}/10. ${idea.pitch || ""}`.trim();

export const ShareButton = ({ idea, testId = "idea-share-btn" }) => {
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState(null);
  const sig = `${idea.plan?.length || 0}-${idea.competitors?.length || 0}`;

  const ensureLink = async () => {
    try {
      let id = idea.share_sig === sig ? idea.share_id : null;
      if (!id) {
        const { data } = await axios.post(`${API}/shared`, { idea }, { headers: accountHeaders() });
        id = data.share_id;
        ideasStore.update(idea.id, { share_id: id, share_sig: sig });
      }
      setUrl(`${process.env.REACT_APP_BACKEND_URL}/api/s/${id}`);
    } catch {
      toast.error("Impossibile creare il link. Riprova.");
      setOpen(false);
    }
  };

  const onOpen = (v) => {
    setOpen(v);
    if (v && !url) ensureLink();
  };

  return (
    <Popover open={open} onOpenChange={onOpen}>
      <PopoverTrigger asChild>
        <button data-testid={testId} title="Condividi"
          className="inline-flex items-center gap-2 rounded-full border border-white/10 px-4 py-2.5 text-sm font-semibold text-slate-200 transition-colors duration-200 hover:border-amber-500/50 hover:text-amber-300">
          <Share2 className="w-4 h-4" /> Condividi
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto max-w-[92vw] rounded-2xl border-white/10 bg-[#12141F] p-4 shadow-2xl shadow-black/60" data-testid="share-popover">
        <div className="text-xs uppercase tracking-wider text-slate-500 mb-3">Condividi l'idea</div>
        {url ? <SocialShare url={url} text={shareText(idea)} prefix="share" compact /> : <p className="text-sm text-slate-400" data-testid="share-creating">Creo il link…</p>}
        <div className="mt-4 pt-4 border-t border-white/5">
          <p className="text-xs text-slate-500 mb-2.5">Vuoi sapere quando la tua idea riceve un Mi piace o un commento?</p>
          <DailyPushToggle label="Avvisami su voti e commenti" hideWhenActive compact />
        </div>
      </PopoverContent>
    </Popover>
  );
};
